import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const CollapsibleSection = ({
  title,
  icon: Icon,
  children,
  defaultOpen = true,
  colorScheme = 'gray', // gray, blue, purple, orange, amber, red
  alwaysOpen = false // For IMMEDIATE ACTIONS
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const colorClasses = {
    red: {
      bg: 'bg-red-50 dark:bg-red-900/20',
      border: 'border-red-500 dark:border-red-600',
      text: 'text-red-900 dark:text-red-100',
      icon: 'text-red-600 dark:text-red-400'
    },
    blue: {
      bg: 'bg-blue-50 dark:bg-blue-900/20',
      border: 'border-blue-300 dark:border-blue-600',
      text: 'text-blue-900 dark:text-blue-100',
      icon: 'text-blue-600 dark:text-blue-400'
    },
    purple: {
      bg: 'bg-purple-50 dark:bg-purple-900/20',
      border: 'border-purple-300 dark:border-purple-600',
      text: 'text-purple-900 dark:text-purple-100',
      icon: 'text-purple-600 dark:text-purple-400'
    },
    orange: {
      bg: 'bg-orange-50 dark:bg-orange-900/20',
      border: 'border-orange-300 dark:border-orange-600',
      text: 'text-orange-900 dark:text-orange-100',
      icon: 'text-orange-600 dark:text-orange-400'
    },
    amber: {
      bg: 'bg-amber-50 dark:bg-amber-900/20',
      border: 'border-amber-300 dark:border-amber-600',
      text: 'text-amber-900 dark:text-amber-100',
      icon: 'text-amber-600 dark:text-amber-400'
    },
    teal: {
      bg: 'bg-teal-50 dark:bg-teal-900/20',
      border: 'border-teal-400 dark:border-teal-500',
      text: 'text-teal-900 dark:text-teal-100',
      icon: 'text-teal-600 dark:text-teal-400'
    },
    gray: {
      bg: 'bg-white dark:bg-gray-800',
      border: 'border-gray-200 dark:border-gray-700',
      text: 'text-gray-900 dark:text-white',
      icon: 'text-gray-700 dark:text-gray-300'
    }
  };

  const colors = colorClasses[colorScheme];

  const handleToggle = () => {
    if (!alwaysOpen) {
      setIsOpen(!isOpen);
    }
  };

  return (
    <div className={`${colors.bg} border-2 ${colors.border} rounded-xl overflow-hidden`}>
      <button
        onClick={handleToggle}
        className={`w-full p-4 flex items-center justify-between ${alwaysOpen ? 'cursor-default' : 'hover:opacity-80 active:opacity-60'} transition-opacity`}
        disabled={alwaysOpen}
      >
        <div className="flex items-center gap-2">
          {Icon && <Icon size={20} className={colors.icon} />}
          <h3 className={`font-bold ${colors.text} text-lg`}>{title}</h3>
        </div>
        {!alwaysOpen && (
          <div className={colors.icon}>
            {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
          </div>
        )}
      </button>

      {(isOpen || alwaysOpen) && (
        <div className="px-4 pb-4">
          {children}
        </div>
      )}
    </div>
  );
};

export default CollapsibleSection;
